<template>
  <section class="single-project" :class="{ 'project-open': open }">
    <header @click="toggleProject()">
      <div :class="statusClasses">
        {{getStatus(configuration.status)}}
      </div>
      <div class="header-box">
        <div class="heading-group">
          <div class="headline">
            <h2>{{configuration.name}}</h2>
          </div>
          <span class="creation-date">{{getDateFromTimestamp(configuration.creationDate)}}</span>
        </div>
        <button v-if="!open" class="backend-button edit-project">Details</button>
        <button v-else class="backend-button edit-project">Schließen</button>
      </div>
    </header>
      <main v-if="open">
        <section class="left">
          <stack :configuration="configuration.configuration" />
          <div class="configuration-details">
            <h3>Konfiguration</h3>
            <ul>
              <template v-for="(item, index) of selectedItems">
                <template v-if="index < 3">
                  <li :key="item.id">{{item.name}}<span v-if="item.amount > 0">: {{item.amount}}</span></li>
                </template>
                <template v-else>
                  <li v-if="showMoreDetails" :key="item.id">{{item.name}}<span v-if="item.amount > 0">: {{item.amount}}</span></li>
                </template>
              </template>
              <li v-if="selectedItems.length > 3 && !showMoreDetails">...</li>
            </ul>
            <template v-if="selectedItems.length > 3">
              <button v-if="showMoreDetails" @click="toggleDetails()" class="backend-button blue-button less-button">weniger Details</button>
              <button v-else @click="toggleDetails()" class="backend-button blue-button more-button">mehr Details</button>
            </template>
          </div>
        </section>
        <section class="right">
          <!-- Title -->
          <h3>Projektdaten</h3>
          <section class="title-section">
            <template v-if="headingEdit">
              <div class="title-edit">
                <p><strong>Name:</strong> <input v-on:keyup.enter="editHeading('save')" type="text" placeholder="Neuer Name" v-model="newName" maxlength="45" /></p>
                <div class="button-group">
                  <button @click="editHeading('save')" class="edit-button check"></button>
                  <button @click="editHeading('cancel')" class="edit-button cross"></button>
                </div>
              </div>
            </template>
            <template v-else>
              <p @click="editHeading()"><strong>Name:</strong> {{configuration.name}}</p>
              <button @click="editHeading()" class="edit-button edit"></button>
            </template>
          </section>
          <!-- Budget -->
          <section>
            <p><strong>Pauschalpreis:</strong> {{configuration.total}} €</p>
          </section>
          <!-- File Upload -->
          <section class="upload-section">
            <h3>Datei-Upload</h3>
            <template v-if="!showUploadDetailsOne">
              <button @click="toggleShowUploadDetailsOne()" class="backend-button blue-button more-button">Welche Daten werden benötigt?</button>
            </template>
            <template v-else>
              <button @click="toggleShowUploadDetailsOne()" class="backend-button blue-button less-button">weniger anzeigen</button>
              <ul class="data-list">
                <li>Je bestelltem Template ein Screendesign in den zwei folgenden Größen:
                  <ul class="data-list">
                    <li>768px Breite</li>
                    <li>1280px Breite</li>
                  </ul>
                </li>
                <li>Screendesign jedes Use-Case oder jeder Bildschirmgröße, die Sie pixelgenau umgesetzt haben möchten</li>
                <li>Alle verwendeten Grafiken (z. B. Logos, Icons oder Hintergrundgrafiken)</li>
                <li>Alle verwendeten Bilder</li>
              </ul>
            </template>
            <template v-if="!showUploadDetailsTwo">
              <button @click="toggleShowUploadDetailsTwo()" class="backend-button blue-button more-button">Wie sind die Daten hochzuladen?</button>
            </template>
            <template v-else>
              <button @click="toggleShowUploadDetailsTwo()" class="backend-button blue-button less-button">weniger anzeigen</button>
              <ul class="data-list">
                <li>Einzelne Dateien (keine Zip-Archive o. Ä.)</li>
                <li>Screendesigns als PDF mit eingebetteten Grafiken als Vektoren</li>
                <li>Oder Screendesigns als PSD und Grafiken einzeln im Format SVG ohne Hintergrundfarbe</li>
                <li>Bilder in geeigneter Qualität für's Web (Faustregel: Maximal 2 Megabyte je Bild)</li>
                <li>Je Datei maximal 12 Megabyte</li>
              </ul>
            </template>
            <template v-if="!verified">
              <p class="dropzone-dummy"><strong>Bestätigen Sie Ihre E-Mail, um hier Daten hochzuladen.</strong></p>
            </template>
            <template v-else>
              <dropzone
                ref="imgDropZone"
                id="customdropzone"
                :options="dropzoneOptions"
                @vdropzone-complete="afterComplete"
              ></dropzone>
            </template>
              <section v-if="images.length > 0" class="user-uploads">
                <template v-if="!showUploads">
                  <button @click="toggleShowUploads()" class="backend-button blue-button more-button">Ihre Uploads anzeigen</button>
                </template>
                <template v-else>
                  <button @click="toggleShowUploads()" class="backend-button blue-button less-button">Uploads ausblenden</button>
                  <ul class="uploads">
                    <li v-for="image of images" :key="image.name">
                      <template v-if="image.type === 'application/pdf'">
                        <button @click="deleteFile(image.path)" class="edit-button delete-button delete"></button>
                        <a :href="image.href" target="_blank" class="single-upload pdf-placeholder">
                          <span class="single-upload-name">{{image.name}}</span>
                        </a>
                      </template>
                      <template v-else-if="image.type === 'application/x-photoshop'">
                        <button @click="deleteFile(image.path)" class="edit-button delete-button delete"></button>
                        <a :href="image.href" target="_blank" class="single-upload psd-placeholder">
                          <span class="single-upload-name">{{image.name}}</span>
                        </a>
                      </template>
                      <template v-else>
                        <button @click="deleteFile(image.path)" class="edit-button delete-button delete"></button>
                        <a :href="image.href" target="_blank" class="single-upload" :style="{ 'background-image' : 'url(' + image.href + ')'}">
                          <span class="single-upload-name">{{image.name}}</span>
                        </a>
                      </template>
                    </li>
                  </ul>
                </template>
              </section>
          </section>
        </section>
      </main>
      <footer v-if="open">
        <button v-if="configuration.status < 3" @click="deleteProject()" class="backend-button delete-button">Projekt löschen</button>
      </footer>
  </section>
</template>
<script>
import Stack from '@/components/Stack.vue'
import dropzone from 'vue2-dropzone'
let uuid = require('uuid')
export default {
  name: 'SingleProjekt',
  components: {
    dropzone,
    Stack
  },
  props: {
    verified: {
      type: Boolean
    },
    configuration: {
      type: Object,
      required: true
    },
    parentToggle: {
      type: Boolean
    },
    uid: {
      type: String,
      default: 'error_unser_uid@singleproject.vue'
    }
  },
  data: function () {
    return {
      showUploads: false,
      showUploadDetailsOne: false,
      showUploadDetailsTwo: false,
      loadingImages: false,
      open: false,
      headingEdit: false,
      newName: '',
      showMoreDetails: false,
      dropzoneOptions: {
        url: 'https://clickzip.de', // https://httpbin.org/post
        thumbnailWidth: 160,
        thumbnailHeight: 160,
        maxFilesize: 12,
        addRemoveLinks: false,
        acceptedFiles: '.jpg, .jpeg, .png, .svg, .pdf, .psd',
        dictDefaultMessage: `<p class='text-default'>Dateien hierhin ziehen oder hier klicken</p><p class="form-text">Erlaubte Formate: .jpg .png .svg .pdf .psd</p>`
      },
      images: []
    }
  },
  computed: {
    selectedItems: function () {
      return this.configuration.configuration.filter(item => item.status === true)
    },
    statusClasses: function () {
      let step = ''
      switch (this.configuration.status) {
        case 0:
          step = 'step0'
          break
        case 1:
          step = 'step1'
          break
        case 2:
          step = 'step2'
          break
        case 3:
          step = 'step3'
          break
        default:
          break
      }
      return 'status ' + step
    }
  },
  methods: {
    deleteFile: function (path) {
      if (confirm('Sie löschen die Datei.\n\nDas Löschen kann nicht rückgängig gemacht werden.')) {
        let storageRef = this.$root.strg.ref()
        var desertRef = storageRef.child(path)
        // Delete the file
        desertRef.delete().then(x => {
          this.images = this.images.filter(image => image.path !== path) // remove from array
          // File deleted successfully
        }).catch(function (error) {
          console.error(error.code)
        })
      }
    },
    getFiles: function () {
      this.loadingImages = true
      this.images = []
      // Create a reference under which you want to list
      let storageRef = this.$root.strg.ref('screendesigns')
      let listRef = storageRef.child(this.uid + '/' + this.configuration.id)
      // Find all the prefixes and items.
      listRef.listAll().then(res => {
        res.items.forEach(itemRef => {
          // All the items under listRef.
          let file = {
            path: '',
            href: '',
            id: '',
            name: '',
            type: '',
            creationDate: ''
          }
          itemRef.getMetadata().then(metadata => {
            console.log(metadata)
            file.path = metadata.fullPath
            file.id = metadata.name
            file.name = metadata.customMetadata.originalName
            file.creationTime = metadata.timeCreated
            file.type = metadata.contentType
          }).catch(error => {
            console.error('Error getting metadata: ' + error.code)
          })
          itemRef.getDownloadURL().then(download => {
            file.href = download
          }).catch(error => {
            console.error('Error getting url: ' + error.code)
          })
          this.images.push(file)
          this.loadingImages = false
        })
      }).catch(error => {
        this.loadingImages = false
        console.error(error)
      })
    },
    async afterComplete (upload) { // upload img to firebase
      console.log(upload)
      var imageName = uuid.v1()
      this.isLoading = true
      try {
        console.log('1')
        // save image
        let file = upload
        let ending
        let metaType
        console.log(file.type)
        switch (file.type) {
          case 'image/png':
            metaType = 'image/png'
            ending = '.png'
            break
          case 'image/jpeg':
            metaType = 'image/jpeg'
            ending = '.jpg'
            break
          case 'image/svg+xml':
            metaType = 'image/svg+xml'
            ending = '.svg'
            break
          case 'application/pdf':
            metaType = 'application/pdf'
            ending = '.pdf'
            break
          case 'application/x-photoshop':
          case 'image/vnd.adobe.photoshop':
          case 'application/photoshop':
          case 'application/psd':
          case 'image/psd':
            metaType = 'application/x-photoshop'
            ending = '.psd'
            break
          default:
            metaType = 'undefined'
            ending = '.undefined'
            break
        }
        var metadata = {
          contentType: metaType,
          customMetadata: {
            userID: this.uid,
            originalName: file.name
          }
        }
        console.log('2')
        var storageRef = this.$root.strg.ref('screendesigns')
        var imageRef = storageRef.child(this.uid + '/' + this.configuration.id + '/' + imageName + ending)
        console.log('3')
        console.log('Uploading....')
        await imageRef.put(file, metadata)
        this.getFiles()
        console.log('Did it!')
        // var downloadURL = await imageRef.getDownloadURL()
        // this.images.push({ src: downloadURL })
      } catch (error) {
        console.error(error.code)
        console.log(error)
      }
      this.$refs.imgDropZone.removeFile(upload)
    },
    toggleShowUploadDetailsOne: function () {
      this.showUploadDetailsTwo = false
      this.showUploadDetailsOne = !this.showUploadDetailsOne
    },
    toggleShowUploadDetailsTwo: function () {
      this.showUploadDetailsOne = false
      this.showUploadDetailsTwo = !this.showUploadDetailsTwo
    },
    toggleDetails: function () {
      this.showMoreDetails = !this.showMoreDetails
    },
    toggleShowUploads: function () {
      this.showUploads = !this.showUploads
    },
    toggleProject: function () {
      this.open = !this.open
    },
    editHeading: function (state) {
      if (this.verified) {
        if (state === 'save' && this.newName !== '') {
          this.$root.updateConfigurationName(this.configuration.id, this.newName)
        }
        this.newName = ''
        this.headingEdit = !this.headingEdit
      } else {
        alert('Bevor Sie weitere Einstellungen vornehmen können, müssen Sie Ihre E-Mail-Adresse bestätigen. Sehen Sie bitte auch in Ihrem Spam-Ordner nach.')
      }
    },
    deleteProject: function () {
      if (this.verified) {
        let sure = confirm('Sie löschen das Projekt.\n\nDas Löschen kann nicht rückgängig gemacht werden.')
        if (sure) {
          this.$root.deleteConfiguration(this.configuration.id)
        }
      } else {
        alert('Bevor Sie weitere Einstellungen vornehmen können, müssen Sie Ihre E-Mail-Adresse bestätigen. Sehen Sie bitte auch in Ihrem Spam-Ordner nach.')
      }
    },
    getDateFromTimestamp: function (timestamp) {
      if (timestamp !== null) {
        let fullDate = timestamp.toDate()
        let day = fullDate.getDate().toString()
        if (day.length === 1) {
          day = '0' + day
        }
        let month = fullDate.getMonth() + 1
        if (month < 10) {
          month = '0' + month
        }
        let year = fullDate.getFullYear()
        return day + '.' + month + '.' + year
      } else {
        return 'NaN'
      }
    },
    getStatus: function (status) {
      switch (status) {
        case 0:
          return 'Anfrage eingegangen'
        case 1:
          return 'Angebot in Erstellung'
        case 2:
          return 'Überprüfen Sie Ihr Angebot'
        case 3:
          return 'Projekt gestartet'
        default:
          return 'NaN'
      }
    }
  },
  mounted: function () {
    this.getFiles()
  },
  watch: {
    open: function (value) {
      if (value === false) {
        this.showMoreDetails = false
        this.showUploadDetailsOne = false
        this.showUploadDetailsTwo = false
        this.showUploads = false
      }
    },
    parentToggle: function () {
      this.open = false
    }
  }
}
</script>
<style lang="scss">
@import "../assets/css/variables.scss";
.single-project {
  @include tile();
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
  .button-group {
    display: flex;
    flex-direction: row;
  }
  .backend-button {
    @include backend-button();
    &.delete-button {
      color: $errorColorPrimary;
    }
    &.blue-button {
      color: #fff;
      &:hover {
        background: #728DF8;
      }
    }
    &.less-button {
      margin-top: 8px;
      display: flex;
      align-items: center;
      &:before {
        margin-top: 2px;
        margin-right: 6px;
        width: 21px;
        height: 21px;
        min-width: 21px;
        display: block;
        content: '';
        background-image: url('../assets/img/icons/roundLessWhite.svg');
      }
    }
    &.more-button {
      margin-top: 8px;
      display: flex;
      align-items: center;
      &:before {
        margin-top: 2px;
        margin-right: 6px;
        width: 21px;
        height: 21px;
        min-width: 21px;
        display: block;
        content: '';
        background-image: url('../assets/img/icons/roundMoreWhite.svg');
      }
    }
  }
  .edit-button {
    touch-action: manipulation;
    background-color: none;
    background-color: transparent;
    outline: none;
    border: none;
    margin: 0 0 0 8px;
    width: 21px;
    min-width: 21px;
    height: 21px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    opacity: 1;
    transition: opacity 0.2s;
    padding: 0;
    &.edit {
      background-image: url('../assets/img/icons/roundEditWhite.svg');
    }
    &.cross {
      background-image: url('../assets/img/icons/roundCrossWhite.svg');
    }
    &.check {
      background-image: url('../assets/img/icons/roundCheckWhite.svg');
    }
    &.delete {
      background-image: url('../assets/img/icons/roundTrashBlue.svg');
    }
  }
  header {
    background: #fafafa;
    padding: 15px 20px;
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    &:hover {
      cursor: pointer;
    }
    .status {
      display: flex;
      text-align: left;
      flex-direction: row;
      align-items: center;
      font-size: 12px;
      line-height: 1.1;
      width: 100%;
      margin: 2px 0 4px 0;
      color: $secondaryFontColor;
      &:before {
        display: block;
        content: '';
        width: 10px;
        height: 10px;
        border-radius: 5px;
        margin-right: 6px;
      }
      &.step0 {
        &:before {
          background: #B5B5B5;
        }
      }
      &.step1 {
        &:before {
          background: #ffb96f;
        }
      }
      &.step2 {
        &:before {
          background: #5bd52f;
        }
      }
      &.step3 {
        &:before {
          background: $primaryColor;
        }
      }
    }
    .header-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      .heading-group {
        display: flex;
        flex-direction: column;
        flex-grow: 2;
        .headline {
          display: flex;
          flex-direction: row;
          align-items: center;
          h2 {
            font-size: 18px;
            font-family: $primaryFont;
            font-weight: $primaryFontBold;
            color: $primaryFontColor;
            line-height: 1.1;
            margin: 5px 10px 5px 0;
            hyphens: auto;
          }
        }
        .creation-date {
          color: $secondaryFontColor;
          font-size: 16px;
        }
      }
    }
  }
  main {
    padding: 40px 20px;
    display: flex;
    flex-direction: column-reverse;
    background-color: $primaryColor;
    color: #fff;
    p {
      margin-bottom: 4px;
    }
    strong {
      font-weight: $secondaryFontBold;
    }
    input {
      font-size: 16px;
      font-family: $secondaryFont;
      font-weight: $secondaryFontNormal;
      color: #fff;
      padding: 0;
      margin: 0;
      outline: none;
      border: none;
      background-color: none;
      background-color: transparent;
      line-height: 1.5;
      width: auto;
    }
    .left {
      width: 100%;
      display: flex;
      flex-direction: column;
      .configuration-details {
        width: 100%;
        padding: 40px 0 0 0;
        ul {
          margin: 10px 0 0 0;
          padding: 0 0 0 20px;
          li {
            list-style: none;
            position: relative;
            font-size: 16px;
            margin-bottom: 4px;
          }
          li:before {
            content:'';
            display:inline-block;
            background-position:center center;
            background-repeat:no-repeat;
            margin-right:8px;
            position: absolute;
            top: 6px;
            left: -20px;
            width: 14px;
            height: 14px;
            background-image: url('../assets/img/icons/listCheckWhite.svg');
          }
        }
      }
    }
    .right {
      width: 100%;
      margin-bottom: 40px;
      .upload-section {
        .data-list {
          margin: 10px 0 0 0;
          padding: 0 0 0 40px;
          ul {
            margin: 4px 0 0 0;
            padding: 0 0 0 20px;
          }
          li {
            list-style: none;
            position: relative;
            font-size: 16px;
            margin-bottom: 4px;
          }
          li:before {
            content:'';
            display:inline-block;
            background-position:center center;
            background-repeat:no-repeat;
            margin-right:8px;
            position: absolute;
            top: 6px;
            left: -20px;
            width: 14px;
            height: 14px;
            background-image: url('../assets/img/icons/listCheckWhite.svg');
          }
        }
        .uploads {
          margin: 10px -10px 0 -10px;
          padding: 0;
          display: flex;
          flex-wrap: wrap;
          li {
            margin: 0;
            padding: 10px;
            list-style: none;
            position: relative;
            width: 50%;
            .delete-button {
              position: absolute;
              top: 20px;
              right: 20px;
              width: 30px;
              height: 30px;
              margin: 0;
              z-index: 2;
            }
            .single-upload {
              text-decoration: none;
              display: flex;
              position: relative;
              background-position: center;
              background-size: cover;
              width: 100%;
              height: 160px;
              background-color: #fff;
              &.pdf-placeholder {
                display: flex;
                position: relative;
                background: #fff;
                align-items: center;
                justify-content: center;
                &:before {
                  content: 'PDF';
                  text-align: center;
                  width: 42px;
                  height: 42px;
                  color: #fff;
                  background: $primaryColor;
                  padding: 11px 0;
                  border-radius: 21px;
                  position: relative;
                  transform: translateY(-14px);
                  font-weight: $secondaryFontBold;
                  font-family: $secondaryFont;
                  font-size: 14px;
                }
              }
              &.psd-placeholder {
                display: flex;
                position: relative;
                background: #fff;
                align-items: center;
                justify-content: center;
                &:before {
                  content: 'PSD';
                  text-align: center;
                  width: 42px;
                  height: 42px;
                  color: #fff;
                  background: $primaryColor;
                  padding: 11px 0;
                  border-radius: 21px;
                  position: relative;
                  transform: translateY(-14px);
                  font-weight: $secondaryFontBold;
                  font-family: $secondaryFont;
                  font-size: 14px;
                }
              }
              /*
              img {
                width: auto;
                height: auto;
                max-width: 100%;
                max-height: 160px;
              }
              */
              .single-upload-name {
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                background: #000;
                background: rgba(0,0,0,0.6);
                font-size: 14px;
                padding: 10px 20px;
                font-family: $secondaryFont;
                font-weight: $secondaryFontBold;
                color: #fff;
                overflow: auto;
                height: 40px;
              }
            }
          }
        }
      }
    }
    section {
      &.title-section {
        display: flex;
        align-items: center;
        margin-bottom: 4px;
        p {
          margin-bottom: 5px;
        }
        button {
          margin-bottom: 7px;
        }
        .title-edit {
          display: flex;
          flex-direction: row;
          button {
            margin-bottom: 0;
          }
          p {
            margin-bottom: 0;
            display: flex;
            input {
              border-radius: 0;
              width: 120px;
              margin-left: 6px;
              padding-bottom: 4px;
              border-bottom: 1px solid #728df8;
            }
          }
        }
      }
    }
  }
  footer {
    display: flex;
    justify-content: end;
    justify-content: flex-end;
    padding: 15px 20px;
  }
}
@media(min-width:767px) {
  .single-project {
    margin-bottom: 30px;
    &:last-child {
      margin-bottom: 0;
    }
    header {
      flex-wrap: nowrap;
      .status {
        text-align: center;
        flex-direction: column;
        width: 80px;
        margin: 0 12px 0 0;
        &:before {
          margin-bottom: 6px;
          margin-right: 0;
        }
      }
      h2 {
      }
    }
    main {
      flex-direction: row;
      .left {
        flex-direction: column;
        width: 50%;
        padding: 0 20px 0 0;
        .configuration-details {
          width: 100%;
          padding: 40px 0 0 0;
        }
      }
      .right {
        width: 50%;
        margin: 0;
        padding: 0 0 0 20px;
        border-left: 1px solid #728df8;
      }
    }
  }
}
@media(min-width:1180px) {
  .single-project {
    header {
      padding: 20px 20px;
    }
  }
}
/*
 * The MIT License
 * Copyright (c) 2012 Matias Meno <m@tias.me>
 */
@-webkit-keyframes passing-through {
  0% {
    opacity: 0;
    -webkit-transform: translateY(40px);
    -moz-transform: translateY(40px);
    -ms-transform: translateY(40px);
    -o-transform: translateY(40px);
    transform: translateY(40px); }
  30%, 70% {
    opacity: 1;
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
    -o-transform: translateY(0px);
    transform: translateY(0px); }
  100% {
    opacity: 0;
    -webkit-transform: translateY(-40px);
    -moz-transform: translateY(-40px);
    -ms-transform: translateY(-40px);
    -o-transform: translateY(-40px);
    transform: translateY(-40px); } }
@-moz-keyframes passing-through {
  0% {
    opacity: 0;
    -webkit-transform: translateY(40px);
    -moz-transform: translateY(40px);
    -ms-transform: translateY(40px);
    -o-transform: translateY(40px);
    transform: translateY(40px); }
  30%, 70% {
    opacity: 1;
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
    -o-transform: translateY(0px);
    transform: translateY(0px); }
  100% {
    opacity: 0;
    -webkit-transform: translateY(-40px);
    -moz-transform: translateY(-40px);
    -ms-transform: translateY(-40px);
    -o-transform: translateY(-40px);
    transform: translateY(-40px); } }
@keyframes passing-through {
  0% {
    opacity: 0;
    -webkit-transform: translateY(40px);
    -moz-transform: translateY(40px);
    -ms-transform: translateY(40px);
    -o-transform: translateY(40px);
    transform: translateY(40px); }
  30%, 70% {
    opacity: 1;
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
    -o-transform: translateY(0px);
    transform: translateY(0px); }
  100% {
    opacity: 0;
    -webkit-transform: translateY(-40px);
    -moz-transform: translateY(-40px);
    -ms-transform: translateY(-40px);
    -o-transform: translateY(-40px);
    transform: translateY(-40px); } }
@-webkit-keyframes slide-in {
  0% {
    opacity: 0;
    -webkit-transform: translateY(40px);
    -moz-transform: translateY(40px);
    -ms-transform: translateY(40px);
    -o-transform: translateY(40px);
    transform: translateY(40px); }
  30% {
    opacity: 1;
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
    -o-transform: translateY(0px);
    transform: translateY(0px); } }
@-moz-keyframes slide-in {
  0% {
    opacity: 0;
    -webkit-transform: translateY(40px);
    -moz-transform: translateY(40px);
    -ms-transform: translateY(40px);
    -o-transform: translateY(40px);
    transform: translateY(40px); }
  30% {
    opacity: 1;
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
    -o-transform: translateY(0px);
    transform: translateY(0px); } }
@keyframes slide-in {
  0% {
    opacity: 0;
    -webkit-transform: translateY(40px);
    -moz-transform: translateY(40px);
    -ms-transform: translateY(40px);
    -o-transform: translateY(40px);
    transform: translateY(40px); }
  30% {
    opacity: 1;
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
    -o-transform: translateY(0px);
    transform: translateY(0px); } }
@-webkit-keyframes pulse {
  0% {
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
    -ms-transform: scale(1);
    -o-transform: scale(1);
    transform: scale(1); }
  10% {
    -webkit-transform: scale(1.1);
    -moz-transform: scale(1.1);
    -ms-transform: scale(1.1);
    -o-transform: scale(1.1);
    transform: scale(1.1); }
  20% {
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
    -ms-transform: scale(1);
    -o-transform: scale(1);
    transform: scale(1); } }
@-moz-keyframes pulse {
  0% {
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
    -ms-transform: scale(1);
    -o-transform: scale(1);
    transform: scale(1); }
  10% {
    -webkit-transform: scale(1.1);
    -moz-transform: scale(1.1);
    -ms-transform: scale(1.1);
    -o-transform: scale(1.1);
    transform: scale(1.1); }
  20% {
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
    -ms-transform: scale(1);
    -o-transform: scale(1);
    transform: scale(1); } }
@keyframes pulse {
  0% {
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
    -ms-transform: scale(1);
    -o-transform: scale(1);
    transform: scale(1); }
  10% {
    -webkit-transform: scale(1.1);
    -moz-transform: scale(1.1);
    -ms-transform: scale(1.1);
    -o-transform: scale(1.1);
    transform: scale(1.1); }
  20% {
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
    -ms-transform: scale(1);
    -o-transform: scale(1);
    transform: scale(1); } }
.dropzone, .dropzone * {
  box-sizing: border-box; }

.dropzone {
  min-height: 150px;
  border: 2px solid rgba(0, 0, 0, 0.3);
  background: white;
  padding: 20px 20px; }
  .dropzone.dz-clickable {
    cursor: pointer; }
    .dropzone.dz-clickable * {
      cursor: default; }
    .dropzone.dz-clickable .dz-message, .dropzone.dz-clickable .dz-message * {
      cursor: pointer; }
  .dropzone.dz-started .dz-message {
    display: none; }
  .dropzone.dz-drag-hover {
    border-style: solid; }
    .dropzone.dz-drag-hover .dz-message {
      opacity: 0.5; }
  .dropzone .dz-message {
    text-align: center;
    margin: 2em 0; }
  .dropzone .dz-preview {
    position: relative;
    display: inline-block;
    vertical-align: top;
    margin: 16px;
    min-height: 100px; }
    .dropzone .dz-preview:hover {
      z-index: 1000; }
      .dropzone .dz-preview:hover .dz-details {
        opacity: 1; }
    .dropzone .dz-preview.dz-file-preview .dz-image {
      border-radius: 20px;
      background: #999;
      background: linear-gradient(to bottom, #eee, #ddd); }
    .dropzone .dz-preview.dz-file-preview .dz-details {
      opacity: 1; }
    .dropzone .dz-preview.dz-image-preview {
      background: white; }
      .dropzone .dz-preview.dz-image-preview .dz-details {
        -webkit-transition: opacity 0.2s linear;
        -moz-transition: opacity 0.2s linear;
        -ms-transition: opacity 0.2s linear;
        -o-transition: opacity 0.2s linear;
        transition: opacity 0.2s linear; }
    .dropzone .dz-preview .dz-remove {
      font-size: 14px;
      text-align: center;
      display: block;
      cursor: pointer;
      border: none; }
      .dropzone .dz-preview .dz-remove:hover {
        text-decoration: underline; }
    .dropzone .dz-preview:hover .dz-details {
      opacity: 1; }
    .dropzone .dz-preview .dz-details {
      z-index: 20;
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      font-size: 13px;
      min-width: 100%;
      max-width: 100%;
      padding: 2em 1em;
      text-align: center;
      color: rgba(0, 0, 0, 0.9);
      line-height: 150%; }
      .dropzone .dz-preview .dz-details .dz-size {
        margin-bottom: 1em;
        font-size: 16px; }
      .dropzone .dz-preview .dz-details .dz-filename {
        white-space: nowrap; }
        .dropzone .dz-preview .dz-details .dz-filename:hover span {
          border: 1px solid rgba(200, 200, 200, 0.8);
          background-color: rgba(255, 255, 255, 0.8); }
        .dropzone .dz-preview .dz-details .dz-filename:not(:hover) {
          overflow: hidden;
          text-overflow: ellipsis; }
          .dropzone .dz-preview .dz-details .dz-filename:not(:hover) span {
            border: 1px solid transparent; }
      .dropzone .dz-preview .dz-details .dz-filename span, .dropzone .dz-preview .dz-details .dz-size span {
        background-color: rgba(255, 255, 255, 0.4);
        padding: 0 0.4em;
        border-radius: 3px; }
    .dropzone .dz-preview:hover .dz-image img {
      -webkit-transform: scale(1.05, 1.05);
      -moz-transform: scale(1.05, 1.05);
      -ms-transform: scale(1.05, 1.05);
      -o-transform: scale(1.05, 1.05);
      transform: scale(1.05, 1.05);
      -webkit-filter: blur(8px);
      filter: blur(8px); }
    .dropzone .dz-preview .dz-image {
      border-radius: 20px;
      overflow: hidden;
      width: 120px;
      height: 120px;
      position: relative;
      display: block;
      z-index: 10; }
      .dropzone .dz-preview .dz-image img {
        display: block; }
    .dropzone .dz-preview.dz-success .dz-success-mark {
      -webkit-animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);
      -moz-animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);
      -ms-animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);
      -o-animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);
      animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1); }
    .dropzone .dz-preview.dz-error .dz-error-mark {
      opacity: 1;
      -webkit-animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);
      -moz-animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);
      -ms-animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);
      -o-animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);
      animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1); }
    .dropzone .dz-preview .dz-success-mark, .dropzone .dz-preview .dz-error-mark {
      pointer-events: none;
      opacity: 0;
      z-index: 500;
      position: absolute;
      display: block;
      top: 50%;
      left: 50%;
      margin-left: -27px;
      margin-top: -27px; }
      .dropzone .dz-preview .dz-success-mark svg, .dropzone .dz-preview .dz-error-mark svg {
        display: block;
        width: 54px;
        height: 54px; }
    .dropzone .dz-preview.dz-processing .dz-progress {
      opacity: 1;
      -webkit-transition: all 0.2s linear;
      -moz-transition: all 0.2s linear;
      -ms-transition: all 0.2s linear;
      -o-transition: all 0.2s linear;
      transition: all 0.2s linear; }
    .dropzone .dz-preview.dz-complete .dz-progress {
      opacity: 0;
      -webkit-transition: opacity 0.4s ease-in;
      -moz-transition: opacity 0.4s ease-in;
      -ms-transition: opacity 0.4s ease-in;
      -o-transition: opacity 0.4s ease-in;
      transition: opacity 0.4s ease-in; }
    .dropzone .dz-preview:not(.dz-processing) .dz-progress {
      -webkit-animation: pulse 6s ease infinite;
      -moz-animation: pulse 6s ease infinite;
      -ms-animation: pulse 6s ease infinite;
      -o-animation: pulse 6s ease infinite;
      animation: pulse 6s ease infinite; }
    .dropzone .dz-preview .dz-progress {
      opacity: 1;
      z-index: 1000;
      pointer-events: none;
      position: absolute;
      height: 16px;
      left: 50%;
      top: 50%;
      margin-top: -8px;
      width: 80px;
      margin-left: -40px;
      background: rgba(255, 255, 255, 0.9);
      -webkit-transform: scale(1);
      border-radius: 8px;
      overflow: hidden; }
      .dropzone .dz-preview .dz-progress .dz-upload {
        background: #333;
        background: linear-gradient(to bottom, #666, #444);
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        width: 0;
        -webkit-transition: width 300ms ease-in-out;
        -moz-transition: width 300ms ease-in-out;
        -ms-transition: width 300ms ease-in-out;
        -o-transition: width 300ms ease-in-out;
        transition: width 300ms ease-in-out; }
    .dropzone .dz-preview.dz-error .dz-error-message {
      display: block; }
    .dropzone .dz-preview.dz-error:hover .dz-error-message {
      opacity: 1;
      pointer-events: auto; }
    .dropzone .dz-preview .dz-error-message {
      pointer-events: none;
      z-index: 1000;
      position: absolute;
      display: block;
      display: none;
      opacity: 0;
      -webkit-transition: opacity 0.3s ease;
      -moz-transition: opacity 0.3s ease;
      -ms-transition: opacity 0.3s ease;
      -o-transition: opacity 0.3s ease;
      transition: opacity 0.3s ease;
      border-radius: 8px;
      font-size: 13px;
      top: 130px;
      left: -10px;
      width: 140px;
      background: #be2626;
      background: linear-gradient(to bottom, #be2626, #a92222);
      padding: 0.5em 1.2em;
      color: white; }
      .dropzone .dz-preview .dz-error-message:after {
        content: '';
        position: absolute;
        top: -6px;
        left: 64px;
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-bottom: 6px solid #be2626; }
.vue-dropzone{border:2px solid #e5e5e5;font-family:Arial,sans-serif;letter-spacing:.2px;color:#777;transition:.2s linear}.vue-dropzone:hover{background-color:#f6f6f6}.vue-dropzone>i{color:#ccc}.vue-dropzone>.dz-preview .dz-image{border-radius:0;width:100%;height:100%}.vue-dropzone>.dz-preview .dz-image img:not([src]){width:200px;height:200px}.vue-dropzone>.dz-preview .dz-image:hover img{transform:none;-webkit-filter:none}.vue-dropzone>.dz-preview .dz-details{bottom:0;top:0;color:#fff;background-color:rgba(33,150,243,.8);transition:opacity .2s linear;text-align:left}.vue-dropzone>.dz-preview .dz-details .dz-filename{overflow:hidden}.vue-dropzone>.dz-preview .dz-details .dz-filename span,.vue-dropzone>.dz-preview .dz-details .dz-size span{background-color:transparent}.vue-dropzone>.dz-preview .dz-details .dz-filename:not(:hover) span{border:none}.vue-dropzone>.dz-preview .dz-details .dz-filename:hover span{background-color:transparent;border:none}.vue-dropzone>.dz-preview .dz-progress .dz-upload{background:#ccc}.vue-dropzone>.dz-preview .dz-remove{position:absolute;z-index:30;color:#fff;margin-left:15px;padding:10px;top:inherit;bottom:15px;border:2px #fff solid;text-decoration:none;text-transform:uppercase;font-size:.8rem;font-weight:800;letter-spacing:1.1px;opacity:0}.vue-dropzone>.dz-preview:hover .dz-remove{opacity:1}.vue-dropzone>.dz-preview .dz-error-mark,.vue-dropzone>.dz-preview .dz-success-mark{margin-left:auto;margin-top:auto;width:100%;top:35%;left:0}.vue-dropzone>.dz-preview .dz-error-mark svg,.vue-dropzone>.dz-preview .dz-success-mark svg{margin-left:auto;margin-right:auto}.vue-dropzone>.dz-preview .dz-error-message{margin-left:auto;margin-right:auto;left:0;width:100%;text-align:center}.vue-dropzone>.dz-preview .dz-error-message:after{display:none}
/*
.dropzone {
  background: #6683ff;
  border: 3px dashed #9dafff;
  color: #fff;
  padding: 13px;
  min-height: 120px;
  font-family: $secondaryFont;
  font-weight: $secondaryFontBold;
  display: flex;
  flex-wrap: wrap;
  &:hover {
    cursor: pointer;
  }
  .dz-default {
    width: 100%;
    .text-default {
      margin-bottom: 4px;
    }
  }
  .dz-preview {
    padding: 5px;
    .dz-image {
      display: none;
    }
    .dz-details {
      margin: 6px 0 0 0;
      display: flex;
      flex-direction: column-reverse;
      width: 100%;
      .dz-size {
        margin: 0 6px 6px 6px;
        width: 100%;
        font-weight: $secondaryFontNormal;
      }
      .dz-filename {
        margin: 0 6px;
        width: 100%;
      }
    }
    .dz-progress {
      height: 4px;
      width: 100%;
      display: flex;
      .dz-upload {
        height: 4px;
        background: #fff;
      }
    }
    .dz-error-message {
      span {
      }
    }
    .dz-success-mark {
      display: none;
    }
    .dz-error-mark {
      display: none;
    }
  }
}
*/
.single-project {
  .upload-section {
    margin: 30px 0 0 0;
    p {
      margin-bottom: 15px;
    }
  }
}
.dropzone-dummy {
  margin-top: 20px;
  margin-bottom: 20px;
  background: #6683ff;
  border: 3px dashed #9dafff;
  color: #fff;
  padding: 13px;
  min-height: 120px;
  font-family: $secondaryFont;
  font-weight: $secondaryFontNormal;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.dropzone {
  margin-top: 20px;
  margin-bottom: 20px;
  background: #6683ff;
  border: 3px dashed #9dafff;
  color: #fff;
  padding: 13px;
  min-height: 120px;
  font-family: $secondaryFont;
  font-weight: $secondaryFontNormal;
  display: flex;
  flex-wrap: wrap;
  &:hover {
    background: $primaryColor;
  }
  .dz-default {
    width: 100%;
    .text-default {
      font-family: $secondaryFont;
      font-weight: $secondaryFontBold;
    }
    .form-text {
      font-family: $secondaryFont;
      font-weight: $secondaryFontNormal;
      font-size: 12px;
      margin: 0;
    }
  }
  .dz-preview {
    border-radius: 14px;
    overflow: hidden;
    width: 160px;
    height: 160px;
    .dz-image {
      border-radius: 14px;
      overflow: hidden;
    }
    .dz-details {
      background: #3d3d3e;
      border-radius: 14px;
      padding: 20px 15px;
      .dz-size {
        font-family: $secondaryFont;
        font-weight: $secondaryFontNormal;
        font-size: 14px;
        margin-bottom: 0;
      }
      .dz-filename {
        font-family: $secondaryFont;
        font-weight: $secondaryFontBold;
      }
    }
    .dz-progress {
      height: 10px;
      margin-top: -2px;
      .dz-upload {
        background: $primaryColor;
      }
    }
    .dz-error-message {
      bottom: 0;
      top: inherit;
      border-radius: 0;
      opacity: 0;
      background: $errorColorPrimary;
      font-family: $secondaryFont;
      font-weight: $secondaryFontNormal;
      font-size: 10px;
      &:after {
        opacity: 1;
        border-radius: 0;
        bottom: 0;
        top: inherit;
        border: none;
        background: $errorColorPrimary;
        font-family: $secondaryFont;
        font-weight: $secondaryFontNormal;
      }
      span {
      }
    }
    .dz-success-mark {
    }
    .dz-error-mark {
    }
  }
}
</style>
